/**
 * 门户文本默认配置数据
 */
export const home = [
  {
    type: 1,
    thumbnail: "icon-portal-layout_1",
    name: "1:1"
  },
  {
    type: 2,
    thumbnail: "icon-portal-layout_2",
    name: "2:1"
  },
  {
    type: 9,
    thumbnail: "icon-portal-layout_9",
    name: "3:1"
  },
  // {
  //   type: 3,
  //   thumbnail: "icon-portal-layout_3",
  //   enable(params) {
  //     return params.admin
  //   },
  // },
  // {
  //   type: 4,
  //   thumbnail: "icon-portal-layout_4",
  //   enable(params) {
  //     return params.admin
  //   },
  // },
  // {
  //   type: 5,
  //   thumbnail: "icon-portal-layout_5",
  //   enable(params) {
  //     return params.admin
  //   },
  // },
  // {
  //   type: 6,
  //   thumbnail: "icon-portal-layout_6",
  //   enable(params) {
  //     return params.admin
  //   },
  // },
  // //新增瀑布流布局，暂时屏蔽带tab的布局，后续考虑新方案
  // {
  //   type: 7,
  //   thumbnail: "icon-portal-layout_7",
  //   enable(params) {
  //     return params.admin
  //   },
  // },
  // {
  //   type: 8,
  //   thumbnail: "icon-portal-layout_8",
  //   enable(params) {
  //     return params.admin
  //   },
  // }
]

/**
 * 门户文本默认配置数据
 */
export const homeOld = [
  {
    type: 1,
    thumbnail: "icon-portal-layout_1"
  },
  {
    type: 2,
    thumbnail: "icon-portal-layout_2"
  },
  {
    type: 3,
    thumbnail: "icon-portal-layout_3",
    enable(params) {
      return params.admin
    },
  },
  {
    type: 4,
    thumbnail: "icon-portal-layout_4",
    enable(params) {
      return params.admin
    },
  },
  {
    type: 5,
    thumbnail: "icon-portal-layout_5",
    enable(params) {
      return params.admin
    },
  },
  {
    type: 6,
    thumbnail: "icon-portal-layout_6",
    enable(params) {
      return params.admin
    },
  },
  //新增瀑布流布局，暂时屏蔽带tab的布局，后续考虑新方案
  {
    type: 7,
    thumbnail: "icon-portal-layout_7",
    enable(params) {
      return params.admin
    },
    name: "横向标签"
  },
  {
    type: 8,
    thumbnail: "icon-portal-layout_8",
    enable(params) {
      return params.admin
    },
    name: "竖向标签"
  },
  {
    type: 10,
    thumbnail: "icon-portal-accordion",
    enable(params) {
      return params.admin
    },
    name: "手风琴布局"
  }
]
/**
 * 大屏文本默认配置数据
 */
export const bs = [
  {
    type: 1,
    thumbnail: require("../../../assets/images/leftMenu/layout/page_layout_1.png")
  },
  {
    type: 2,
    thumbnail: require("../../../assets/images/leftMenu/layout/page_layout_2.png")
  },
  {
    type: 3,
    thumbnail: require("../../../assets/images/leftMenu/layout/page_layout_3.png")
  },
  {
    type: 4,
    thumbnail: require("../../../assets/images/leftMenu/layout/page_layout_4.png")
  },
  {
    type: 5,
    thumbnail: require("../../../assets/images/leftMenu/layout/page_layout_5.png")
  },
  {
    type: 6,
    thumbnail: require("../../../assets/images/leftMenu/layout/page_layout_6.png")
  }
]

/**
 * app按钮默认配置数据
 */
export const appHome = [
  {
    type: 1,
    thumbnail: "icon-portal-layout_1",
    name: "1:1"
  },
  {
    type: 2,
    thumbnail: "icon-portal-layout_2",
    name: "2:1"
  },
  {
    type: 9,
    thumbnail: "icon-portal-layout_9",
    name: "3:1"
  }
  // {
  //   type: 3,
  //   thumbnail: "icon-portal-layout_3"
  // },
  // {
  //   type: 4,
  //   thumbnail: "icon-portal-layout_4"
  // },
  // {
  //   type: 5,
  //   thumbnail: "icon-portal-layout_5"
  // },
  // {
  //   type: 6,
  //   thumbnail: "icon-portal-layout_6"
  // },
  // {
  //   type: 7,
  //   thumbnail: "icon-portal-layout_7"
  // },
  // {
  //   type: 8,
  //   thumbnail: "icon-portal-layout_8"
  // }
]
export const appHomeOld = [
  {
    type: 1,
    thumbnail: "icon-portal-layout_1"
  },
  {
    type: 2,
    thumbnail: "icon-portal-layout_2"
  },
  {
    type: 3,
    thumbnail: "icon-portal-layout_3"
  },
  {
    type: 4,
    thumbnail: "icon-portal-layout_4"
  },
  {
    type: 5,
    thumbnail: "icon-portal-layout_5"
  },
  {
    type: 6,
    thumbnail: "icon-portal-layout_6"
  },
  {
    type: 7,
    thumbnail: "icon-portal-layout_7"
  },
  {
    type: 8,
    thumbnail: "icon-portal-layout_8"
  },
  {
    type: 10,
    thumbnail: "icon-portal-accordion",
  }
]

/**
 * 抽屉通栏门户文本默认配置数据
 */
export const drawer_home = [
  {
    type: 1,
    thumbnail: require("../../../assets/images/leftMenu/layout/page_layout_1.png")
  }
]

// 移动端抽屉通栏
export const drawer_appHome = [
  {
    type: 1,
    thumbnail: require("../../../assets/images/leftMenu/layout/page_layout_1.png")
  }
]
